export default "__VITE_ASSET__Az81TuIW__"